import { readMeta, writeMeta } from '@/offline/db';

/**
 * Identitas perangkat (FR-AUTH-07).
 *
 * Bukan sidik jari peramban: nilainya acak, dibuat sekali, lalu disimpan. Sidik
 * jari berbasis kanvas/font berubah setiap peramban diperbarui — device binding
 * yang ikut berubah akan memaksa collector mendaftar ulang perangkat yang sama.
 * Nilai acak yang disimpan justru stabil selama cache belum dihapus.
 */

const FINGERPRINT_KEY = 'device.fingerprint';
const LABEL_KEY = 'device.label';

export async function deviceFingerprint(): Promise<string> {
  const stored = await readMeta<string>(FINGERPRINT_KEY);
  if (stored) return stored;

  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(24));
  const value = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  await writeMeta(FINGERPRINT_KEY, value);
  return value;
}

/** Label yang dibaca manusia di daftar perangkat back office. */
export function deviceLabel(): string {
  const agent = navigator.userAgent;
  const platform = /android/i.test(agent)
    ? 'Android'
    : /iphone|ipad|ipod/i.test(agent)
      ? 'iOS'
      : /windows/i.test(agent)
        ? 'Windows'
        : /mac os/i.test(agent)
          ? 'macOS'
          : 'Perangkat';

  const browser = /edg\//i.test(agent)
    ? 'Edge'
    : /chrome|crios/i.test(agent)
      ? 'Chrome'
      : /firefox|fxios/i.test(agent)
        ? 'Firefox'
        : /safari/i.test(agent)
          ? 'Safari'
          : 'Peramban';

  return `${platform} · ${browser}`;
}

export async function storeDeviceLabel(label: string): Promise<void> {
  await writeMeta(LABEL_KEY, label);
}

export async function storedDeviceLabel(): Promise<string> {
  return (await readMeta<string>(LABEL_KEY)) ?? deviceLabel();
}
